import { useEffect } from 'react';

import { Grid, Typography } from '@mui/material';
import SeatAndBelt from './seat-and-belt';

const LiveCarReportInfo = ({
  liveCarReportInfo: { anything, onlyBelt, onlyLoad, both },
}) => {
  let data = [
    {
      text: 'Boş Koltuk Sayısı',
      piece: anything.length || 0,
      seat: false,
      belt: false,
    },
    {
      text: 'Güvenli Koltuk Sayısı',
      piece: both.length || 0,
      seat: true,
      belt: true,
    },
    {
      text: 'Riskli Koltuk Sayısı',
      piece: onlyLoad.length || 0,
      seat: true,
      belt: false,
    },
    {
      text: 'Diğer Koltuk Sayısı',
      piece: onlyBelt.length || 0,
      seat: false,
      belt: false,
    },
  ];
  useEffect(() => {
    data = [
      {
        text: 'Boş Koltuk Sayısı',
        piece: anything.length,
        seat: false,
        belt: false,
      },
      {
        text: 'Güvenli Koltuk Sayısı',
        piece: both.length,
        seat: true,
        belt: true,
      },
      {
        text: 'Riskli Koltuk Sayısı',
        piece: onlyLoad.length,
        seat: true,
        belt: false,
      },
      {
        text: 'Diğer Koltuk Sayısı',
        piece: onlyBelt.length,
        seat: false,
        belt: false,
      },
    ];
  }, [LiveCarReportInfo]);

  return (
    <div
      style={{ height: '80vh' }}
      className="flex justify-center items-center w-full"
    >
      <Grid
        container
        direction={'column'}
        spacing={4}
        alignItems={'center'}
        justifyContent={'center'}
      >
        {data.map(({ belt, seat, text, piece }, index) => (
          <GridItem
            key={index}
            belt={belt}
            seat={seat}
            text={text}
            piece={piece}
          />
        ))}
      </Grid>
    </div>
  );
};

const GridItem = ({ belt, seat, text, piece }) => {
  return (
    <Grid item>
      <Grid
        container
        sx={{
          width: '250px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Grid
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          item
          xs={5}
          sm={12}
        >
          <div
            style={{
              width: '70px',
            }}
          >
            <SeatAndBelt belt={belt} seat={seat} />
          </div>
        </Grid>
        <Grid
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          item
          xs={7}
          sm={12}
        >
          <Typography>
            {text} {piece ? piece : '0'}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default LiveCarReportInfo;
